import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/page/PageEditButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostImage"] */ "/app/components/ui/PostImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/ui/slider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
